/**
 * Утилиты для работы с Service Worker
 */

/**
 * Регистрация Service Worker
 */
export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) {
    console.warn('⚠️ Service Worker не поддерживается в этом браузере');
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
    });

    if (process.env['NODE_ENV'] === 'development') {
      // eslint-disable-next-line no-console
      console.log('✅ Service Worker зарегистрирован:', registration.scope);
    }

    // Обработчик обновлений Service Worker
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            if (process.env['NODE_ENV'] === 'development') {
              // eslint-disable-next-line no-console
              console.log('🔄 Доступна новая версия Service Worker');
            }
            // Можно показать уведомление пользователю о необходимости обновления
          }
        });
      }
    });

    return registration;
  } catch (error) {
    console.error('❌ Ошибка регистрации Service Worker:', error);
    return null;
  }
}

/**
 * Проверка, зарегистрирован ли Service Worker
 */
export async function isServiceWorkerRegistered(): Promise<boolean> {
  if (!('serviceWorker' in navigator)) {
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.getRegistration();
    return !!registration;
  } catch (error) {
    console.error('Ошибка проверки регистрации Service Worker:', error);
    return false;
  }
}

/**
 * Получение регистрации Service Worker
 */
export async function getServiceWorkerRegistration(): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) {
    return null;
  }

  try {
    return await navigator.serviceWorker.ready;
  } catch (error) {
    console.error('Ошибка получения регистрации Service Worker:', error);
    return null;
  }
}

